


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import urlHelperService from '@/core/urlHelper.service';
import { FacetValueViewObject, FacetViewObject, MenuItem } from '@/types/apiServerContract';
import dictionaryService from '@/core/translation/dictionary.service';

type UrlFacet = { key: string, value?: FacetValueViewObject, from?: string, to?: string, productCount?: number }

@Component
export default class FacetQuickView extends Vue {
    @Prop({ required: true, type: Array })
    private facets!: FacetViewObject[];

    @Prop({ type: Array, required: true })
    private menuItems!: MenuItem[];

    private activeFacets: UrlFacet[] = []

    private get categoryFacets() {
        return this.menuItems.filter(x => x.selected);
    }

    // Convert them to an array so i can use them in the template
    private synchronizeFacetsWithUrl() {
        this.activeFacets = [];

        const urlFacets = urlHelperService.getFacets();

        for (const facetKey in urlFacets) {
            const values = urlFacets[facetKey];

            if (facetKey.startsWith('to_')) {
                const facetId = facetKey.slice('to_'.length);
                const facetFromId = 'from_' + facetId;

                const fromFacet = urlFacets[facetFromId];
                if (fromFacet) {
                    const facet = this.facets.find(x => x.facetId === facetId);
                    if (facet) {
                        const rangeFrom = parseFloat(fromFacet[0]);
                        const rangeTo = parseFloat(values[0]);
                        const productCount = facet.values
                            .map(x => ({
                                ...x,
                                nValue: parseFloat(x.key)
                            }))
                            .filter(x => !isNaN(x.nValue) && x.nValue >= rangeFrom && x.nValue <= rangeTo)
                            .reduce((total, value) => {
                                return total + value.productCount;
                            }, 0);

                        this.activeFacets.push({ key: facet.facetId, from: fromFacet[0], to: values[0], productCount: productCount });
                    }
                }

                continue;
            }

            for (const value of values) {
                const facet = this.facets.find(x => x.facetId === facetKey);
                if (!facet) continue;
                const facetValue = facet.values.find(x => x.key === value);
                if (!facetValue) continue;
                this.activeFacets.push({ key: facet.facetId, value: facetValue });
            }
        }
    }

    private highlightFacet(facet: UrlFacet, active: boolean) {
        const activeFacet = this.facets.find(x => x.facetId === facet.key);
        if (activeFacet) {
            activeFacet.highlight = active;
        }
    }

    private highlightCategory(menuItem: MenuItem, active: boolean) {
        menuItem.highlight = active;
    }

    private removeFacet(facet: UrlFacet) {
        if (facet.value) {
            urlHelperService.updateFacetValue(facet.key, facet.value.key, false, facet.value.isFacet);
        } else if (facet.from && facet.to) {
            urlHelperService.setFacetRanges({ facetId: facet.key, rangeFrom: '', rangeTo: '', updateLastFacet: true });
        }
    }

    private removeCategoryFacet(menuItem: MenuItem) {
        menuItem.selected = false;
        urlHelperService.setCategoryIds(menuItem.categoryIds, false, false);
    }

    private resetFilter() {
        urlHelperService.clearFacets();
        urlHelperService.removeQueryParams('categoryIdsKey');
    }

    private getFacetValueName(value: FacetValueViewObject) {
        if (dictionaryService.exists(value.displayLabel)) {
            return dictionaryService.get(value.displayLabel);
        }

        return dictionaryService.translate(value.displayName);
    }

    private getFacetName(key: string) {
        const facet = this.facets.find(x => x.facetId === key);
        if (facet) {
            if (facet.facetDisplayLabel && dictionaryService.exists(facet.facetDisplayLabel)) {
                return dictionaryService.get(facet.facetDisplayLabel);
            }

            return facet.facetDisplayName;
        }

        return undefined;
    }

    get urlFacets() {
        return urlHelperService.getFacets();
    }

    @Watch('urlFacets')
    private onUrlFacetsChange() {
        this.synchronizeFacetsWithUrl();
    }

    @Watch('facets')
    private onFacetsChange() {
        this.synchronizeFacetsWithUrl();
    }

    mounted() {
        this.synchronizeFacetsWithUrl();
    }
}
